import React from "react";
import * as Animate from "react-reveal";

import IncubationIcon from "../../assets/images/svg/incubation.svg";
import LearningIcon from "../../assets/images/svg/intensive-learning.svg";
import InternshipIcon from "../../assets/images/svg/internship.svg";

const CompanyValue = ({ icon, title, description }) => {
  return (
    <div className="text-center md:text-left mb-3 md:mb-0">
      <p className=" py-2 px-2 rounded-lg w-16 lg:w-20 h-16 lg:h-20 mx-auto md:mx-0 ">
        <img src={icon} alt="" />
      </p>

      <h4 className="text-default font-mono text-lg lg:text-xl font-semibold pt-4 pb-6">
        {title}
      </h4>

      <p className="text-default text-sm-15 lg:text-base lg:leading-7">
        {description}
      </p>
    </div>
  );
};

const CompanyValueSection = ({ showImages = true }) => {
  return (
    <section className="pt-16 md:pt-16 md:pb-16 relative -top-20 bg-white md:top-0 rounded-lg">
      <div className="container mx-auto px-4">
        <div className="relative text-center mx-auto">
          <Animate.Fade bottom>
            <h3 className="text-primary font-semibold font-mono text-2xl lg:text-3xl xl:text-4xl w-10/12 lg:w-6/12 xl:w-4/12 mx-auto text-center">
              The Utiva Culture
            </h3>
          </Animate.Fade>
        </div>

        <div className="pt-16 lg:pt-24 pb-12 relative w-full lg:w-11/12 xl:w-10/12 mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-12 lg:gap-16">
            <Animate.Fade bottom>
              <CompanyValue
                icon={IncubationIcon}
                title="Hit heavy, stay small"
                description=" Tightly-knitted, dynamic teams work with more agility,
                  communication, and freedom than large-scale companies."
              />
              <CompanyValue
                icon={LearningIcon}
                title="Ambition by the boatload"
                description="We love people who aim for greatness. 
                They inspire and excite their teammates, raising the bar for all of us."
              />
              <CompanyValue
                icon={InternshipIcon}
                title="Open communication"
                description="We are big fans of transparency for many reasons,
                 but the abridged version is: communication is easier and clearer."
              />
              <CompanyValue
                icon={InternshipIcon}
                title="Autonomy and attitude"
                description="We're a team of self-starters who take 
                serious pride in our work – and it shows."
              />
              <CompanyValue
                icon={IncubationIcon}
                title="Support and win"
                description="When we empower others to succeed, 
                we all win. (And we're not talking about trophies.)"
              />
              <CompanyValue
                icon={LearningIcon}
                title="Teamwork makes the dream work"
                description="We work together to bring our passions 
                and expertise to make Utiva the best it can be."
              />
            </Animate.Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyValueSection;
